'use client'

import { useAppSelector } from '@/src/store/hooks'
import { selectBranding } from '@/src/store/slices/meetData'
import { TPiPTab } from '@/src/store/slices/pip'

export interface ITabItem {
  value: TPiPTab
  icon: JSX.Element

  currentTab?: TPiPTab
  selectCurrentTab?: (value: TPiPTab) => void

  Badge?: string | number | null
}

export const TabItem = ({ value, currentTab, selectCurrentTab, icon, Badge }: ITabItem) => {
  const { text_primary_color } = useAppSelector(selectBranding)

  return (
    <li className={`pip-tab ${currentTab === value ? 'pip-tab-active' : ''}`}>
      <button
        style={{
          color: currentTab === value ? text_primary_color : '',
        }}
        onClick={() => {
          selectCurrentTab(value)
        }}
      >
        {icon}
        {Badge && Badge}
      </button>
    </li>
  )
}
